import { createSelector } from 'reselect';
import { calcPercent, getObjValue } from 'utils/functions';

const isFetchingAssessments = props => getObjValue(props, 'data.loading', true);

const getAssessments = props => getObjValue(props, 'data.listAssessments', []);

const getOpenAssessments = createSelector([getAssessments], assessments =>
  assessments.filter(
    assessment => assessment.status !== 'SUBMITTED' && assessment.status !== 'SUBMITTED_SYNC_SUCCESS' && assessment.status !== 'SUBMITTED_SYNC_FAILED'
  )
);

const getOpenAssessmentsCount = createSelector([getOpenAssessments], assessments => assessments.length);

const getTotalAnsweredQuestionsForOpenAssessments = createSelector([getOpenAssessments], assessments => {
  const reducer = (acc, assessment) => Number(getObjValue(assessment, 'metadata.answeredFields', 0)) + acc;
  return assessments ? assessments.reduce(reducer, 0) : 0;
});

const getTotalQuestionsForOpenAssessments = createSelector([getOpenAssessments], assessments => {
  const reducer = (acc, assessment) => Number(getObjValue(assessment, 'metadata.totalFields', 0)) + acc;
  return assessments ? assessments.reduce(reducer, 0) : 0;
});

const getTotalOpenQuestionsForOpenAssessments = createSelector(
  [getTotalQuestionsForOpenAssessments, getTotalAnsweredQuestionsForOpenAssessments],
  (total, answered) => total - answered
);

const getPercentCompleteForOpenAssessments = createSelector(
  [getTotalQuestionsForOpenAssessments, getTotalAnsweredQuestionsForOpenAssessments],
  (total, answered) => {
    // If there are 0 total questions in an assessment then show 100% complete.
    if (total) {
      return calcPercent(answered, total);
    }
    return 100;
  }
);

export {
  isFetchingAssessments,
  getAssessments,
  getOpenAssessmentsCount,
  getTotalOpenQuestionsForOpenAssessments,
  getPercentCompleteForOpenAssessments,
  getTotalAnsweredQuestionsForOpenAssessments
};
